import { Link } from "react-router-dom";
import NewsletterSignup from "./NewsletterSignup";

function Footer() {
  return (
    <footer className="bg-background-light dark:bg-background-dark border-t border-neutral/20 dark:border-neutral/40 py-8">
      <div className="max-w-7xl mx-auto px-4 sm:px-6">
        <div className="grid grid-cols-1 sm:grid-cols-3 gap-8">
          <div>
            <h3 className="text-lg font-semibold text-text-light dark:text-text-dark mb-4">
              66 Days Journal
            </h3>
            <p className="text-neutral">
              Transform your life with daily journaling and inner child work.
            </p>
          </div>
          <div>
            <h3 className="text-lg font-semibold text-text-light dark:text-text-dark mb-4">
              Quick Links
            </h3>
            <ul className="space-y-2">
              <li><Link to="/" className="text-text-light dark:text-text-dark hover:text-primary">Home</Link></li>
              <li><Link to="/about" className="text-text-light dark:text-text-dark hover:text-primary">About</Link></li>
              <li><Link to="/blog" className="text-text-light dark:text-text-dark hover:text-primary">Blog</Link></li>
              <li><Link to="/newsletter" className="text-text-light dark:text-text-dark hover:text-primary">Newsletter</Link></li>
              <li><Link to="/cycles" className="text-text-light dark:text-text-dark hover:text-primary">Start Journaling</Link></li>
            </ul>
          </div>
          <div>
            <NewsletterSignup />
          </div>
        </div>
        <p className="text-center text-neutral mt-8">
          © 2025 66 Days Journal. All rights reserved.
        </p>
      </div>
    </footer>
  );
}

export default Footer;